export default __webpack_public_path__ + "static/media/carnival.ded2a755.svg";